import $ from "../components/ajax";
const token =localStorage.getItem("token");
//获取大屏统计数据
export const getMapStatics=data=>{
    return $.ajax({
        url:"info/statics/mapStatics",
        type:'GET',
        data:data,
        token,
    })
}

export const getTotalNum=data=>{
    return $.ajax({
        url:"info/statics/totalNum",
        type:'GET',
        data:data,
        token,
    })
}
export const getJump=()=>{
    return $.ajax({
        url:"sys/jump-url ",
        type:'GET'
    })
}